import { app } from "modular-openscriptjs";
import ModalComponent from "../ModalComponent";

const h = app("h");

export default class MapModal extends ModalComponent {
	name = "MapModal";
	
	render(...args) {
		return h.$(
			h.div(
				{
					class: "modal-content border-0 shadow-lg overflow-hidden", // Modern styling
				},
				h.div(
					{
						class: "modal-body p-0", // Remove padding to let map fill or control it internally
					},
					...args,
				),
			),
		);
	}
}
